import React from "react";
import { Link } from "react-router-dom";
import { parseCurrency } from "../../helpers/functions";
import { log } from "../../telemetry/analytics";
import { addToCart } from "../../gtm/ecommerce";
import { freeTrialPlan } from "../../utils/constants";
import { ECOMMERCE_PRODUCT_SELECTED } from "../../telemetry/constants";
import {
  planDescription,
  premiumPlanDescription,
  premiumPlanIds,
} from "../../constants/products";
import {
  Anchor,
  Button,
  Flex,
  Type,
} from "discover.medical.react-component-library";
import {
  Buttons,
  Content,
  Description,
  FreeTrialButton,
  Header,
  Price,
} from "./Plan.styled";

const Plan = ({ plan, className, productCode, productName, showFreeTrial }) => {
  const {
    id,
    description,
    price,
    billingInterval,
    discountPrice,
    productOfferingId,
  } = plan;

  const handleFreeTrialClick = () => {
    handleTelemetry(true);
  };

  const handlePlanClick = () => {
    handleTelemetry();
  };

  const handleTelemetry = (freeTrial) => {
    const productId = freeTrial ? freeTrialPlan.id : id;
    const productPrice = freeTrial ? freeTrialPlan.price : price;
    const productDescription = freeTrial
      ? freeTrialPlan.description
      : description;

    log(ECOMMERCE_PRODUCT_SELECTED, {
      id: productId,
      price: productPrice,
      name: productDescription,
    });
    if (window.Osano && window.Osano.cm.analytics) {
      addToCart(productId, productPrice, productDescription);
    }
  };

  const planType = (id) => {
    switch (id) {
      case premiumPlanIds[productCode]:
        return "premium";
      default:
        return "standard";
    }
  };

  const planDetails = (id) => {
    switch (id) {
      case premiumPlanIds[productCode]:
        return premiumPlanDescription(productName);
      default:
        return planDescription(productName);
    }
  };

  return (
    <Flex column container className={className} backgroundColor="white">
      <Header
        column
        container
        justify={{ content: "center" }}
        align={{ item: "center" }}
        $planType={planType(productOfferingId)}
        padding="lg"
      >
        <Type color="white" fontSize="xl" fontWeight="semibold">
          {description}
        </Type>
      </Header>

      <Content
        column
        container
        align={{ item: "center" }}
        padding="lg"
        height="100%"
      >
        {discountPrice ? (
          <>
            <Type fontSize="xl">
              <s>
                ${parseCurrency(price)}/{billingInterval}
              </s>
            </Type>
            <Type fontSize="xl">
              ${parseCurrency(discountPrice)}/{billingInterval}
            </Type>
          </>
        ) : (
          <Flex
            container
            justify={{ content: "center" }}
            align={{ item: "flex-end" }}
          >
            <Price fontWeight="bold">${parseCurrency(price)}</Price>
            <Type textTransform="capitalize">/{billingInterval}*</Type>
          </Flex>
        )}
        <Description>
          <Type marginBottom="xs">
            <span
              dangerouslySetInnerHTML={{
                __html: planDetails(productOfferingId),
              }}
            ></span>
          </Type>
          {planType(productOfferingId) === "premium" && (
            <Anchor href="https://more.ebsco.com/Dyna-AI.html" target="_blank">
              Learn more about Dyna AI
            </Anchor>
          )}
        </Description>
        <Buttons
          container
          column
          justify={{ content: "flex-end" }}
          align={{ item: "center" }}
        >
          {showFreeTrial && (
            <FreeTrialButton
              to={`/store/free-trial/checkout`}
              onClick={handleFreeTrialClick}
              size="sm"
              linkComponent={Link}
            >
              <Button as="span" variant="primary" size="md">
                Start a 14-day FREE Trial
              </Button>
            </FreeTrialButton>
          )}
          <Anchor
            to={`/store/checkout/${id}`}
            onClick={handlePlanClick}
            linkComponent={Link}
          >
            <Button size="md" as="span" kind="outlined">
              Subscribe
            </Button>
          </Anchor>
        </Buttons>
      </Content>
    </Flex>
  );
};

export default Plan;
